import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TSyainSyozokuMasterGetReq,
  TSyainSyozokuMasterPutReq,
  TSyainSyozokuMasterGetRes,
} from "./TSyainSyozokuHenkou"
import {
  TZyomuinGetRes,
  TZyomuinPutReq,
  TZyomuinPostReq,
} from "../../driver/TZyomuin"

/**
 * 出勤簿に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class SyainSyozokuHenkouListService extends ConnectApi {
  /**
   * 社員所属マスタ一覧取得
   *
   * @param {TSyainSyozokuMasterGetReq} params
   * @memberof SainSyozokuHenkouService
   */
  getSyozokuList = async (params: TSyainSyozokuMasterGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyainSyozokuMasterGetRes[]>> =
        await this.getInner(`/master/syainsyozokuhenkoulist`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   *  社員所属マスタ単体取得
   *
   * @param {number} id
   * @memberof SainSyozokuHenkouService
   */
  getSyozoku = async (id: string | number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyainSyozokuMasterGetRes>> =
        await this.getInner(`/master/syainsyozokuhenkoulist/${id}`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員所属 単体更新
   *
   * @param {TSyainSyozokuMasterPutReq} data
   * @memberof SainSyozokuHenkouService
   */
  putSyozoku = async (
    id: string | number,
    data: TSyainSyozokuMasterPutReq
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `master/syainsyozokuhenkoulist/update/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員所属 単体登録
   *
   * @param {TSyainSyozokuMasterPutReq} data
   * @memberof SainSyozokuHenkouService
   */
  postSyozoku = async (
    id: string | number,
    data: TSyainSyozokuMasterPutReq
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `master/syainsyozokuhenkoulist/register/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員単体登録
   *
   * @param {TZyomuinPostReq} data
   * @param {(param: TApiResponse<TZyomuinGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TZyomuinGetRes>>) => any} reject
   * @memberof KyotenService
   */
  post = async (data: TZyomuinPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinGetRes>> =
        await this.postInner(`/master/zyomuin`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員単体更新
   *
   * @param {TZyomuinPutReq} data
   * @param {(param: TApiResponse<TZyomuinGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TZyomuinGetRes>>) => any} reject
   * @memberof KyotenService
   */
  put = async (id: number, data: TZyomuinPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinGetRes>> =
        await this.putFormDataInner(`/master/zyomuin/${id}`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
